/* eslint-disable prettier/prettier */
// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
export const VERSION = {
  "gitBuildGlobalVersion": "2.6.0",
  "gitBuildTime": "2026-03-05T13:57:46.535Z",
  "gitBuildVersion": "2.6.0",
  "gitCommitId": "e9cb3f2",
  "gitCommitIdFull": "e9cb3f21ea1166fd9c487f35227b45627abf6106",
  "gitCommitTime": "2026-03-05T13:56:30.000Z",
  "version": "2.6.0-2026-03-05T13:56:30.000Z-(e9cb3f2)"
};
